import { Module } from "vuex";
import { RootState, HomeState } from "@/types/home";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state: HomeState = {
  recommendRecipes: null,
  rankingRecipes: null,
  bannerPosition: 0,
  banners: null,
  services: null,
  recentMyList: null,
  myList: null,
  foodRecommendationList: null,
  oneMenuRecommendation: null
};

export const home: Module<HomeState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
